// Фон кнопок — один SVG-слой: заливка пути переключается по состоянию
// (CSS перекрывает атрибут fill), вместо отдельного SVG на каждое состояние.
const TRANSITION =
	"[&_path]:transition-[fill] [&_path]:duration-120 [&_path]:ease-out motion-reduce:[&_path]:transition-none"

export function buttonBgFill({
	disabled,
	interactive = !disabled,
}: {
	disabled?: boolean | undefined
	interactive?: boolean
}) {
	let fill = "[&_path]:fill-[#282A33]"
	if (disabled) fill = "[&_path]:fill-[#C6CBD8]"
	return [
		TRANSITION,
		fill,
		interactive &&
			"group-hover:[&_path]:fill-[#484E5E] group-active:[&_path]:fill-[#484E5E]",
	]
}
